// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleVexImporter = {
  id: "vex-importer",
  mrn: "//iam.api.mondoo.app/roles/vex-importer",
  title: "VEX Importer",
  allowedActions,
} as const;

export type RoleVexImporter = typeof roleVexImporter;
